<template>
    <div class="text-muval-gray-1 mx-auto flex items-center text-sm dark:text-gray-100">
        {{ $filters.capitalize(data) }}
    </div>
</template>

<script>
export default {
    name: 'VehicleType',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>
